import React from "react";
import ClearSearchIcon from "../../../../../Assets/Images/x-circle.svg";

const SearchInput = (props) => {
  const addActiveState = () => {
    document
      .getElementById(props.Id + "-search-input")
      .classList.add("active", "translated");
  };
  const removeActiveState = () => {
    document
      .getElementById(props.Id + "-search-input")
      .classList.remove("active", "translated");
  };
  return (
    <React.Fragment>
      <label
        onFocus={() => addActiveState()}
        onBlur={() => removeActiveState()}
        className="input"
        id={props.Id + "-search-input"}
      >
        <p className="placeholder" id={props.Id + "-placeholder"}>
          {props.PlaceHolder}
        </p>
        <i
          className="feather-search"
          onClick={() => props.filterByNameLike()}
          id="input-icon"
        ></i>
        <input
          type="text"
          onChange={(e) => props.ChangeHandler(e)}
          id="search-input"
        />
        <button onClick={() => props.clearSearch()} id="clear-btn">
          <img alt="" src={ClearSearchIcon} />
        </button>
      </label>
    </React.Fragment>
  );
};
export default SearchInput;
